import { Offcanvas, Nav } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { label: 'Dashboard',            path: '/dashboard',           icon: '⊞' },
  { label: 'Account Status',       path: '/account-status',      icon: '📊' },
  { label: 'Upgrade Slot',          path: '/slots',               icon: '◆' },
  { label: 'Main Wallet',          path: '/wallet',              icon: '◈' },
  { label: 'Earning Wallet',       path: '/wallet?type=earning', icon: '◉' },
  { label: 'Global Fastrack Bonus',path: '/fastrack',            icon: '⚡' },
  { label: 'Generation Bonus',     path: '/generation-records',  icon: '⊕' },
  { label: 'Performance Bonus',    path: '/performance-records', icon: '🏆' },
  { label: 'Direct Referrals',     path: '/referrals',           icon: '◎' },
  { label: 'Level Users',          path: '/level-users',         icon: '≡' },
  { label: 'Rewards',              path: '/rewards',             icon: '🎁' },
  { label: 'My Profile',           path: '/profile',             icon: '◙' },
  { label: 'Support Tickets',      path: '/support-tickets',     icon: '🎫' },
  { label: 'Change Password',      path: '/change-password',     icon: '⚙' },
];

const cyan = '#00e5ff';

const Drawer = ({ show, onHide }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    onHide();
    logout();
    navigate('/login');
  };

  const handleNav = (path) => {
    navigate(path);
    onHide();
  };

  return (
    <Offcanvas show={show} onHide={onHide} placement="start">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          One<span className="accent">Circle</span>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="d-flex flex-column p-0">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            padding: '0.9rem 1.25rem',
            borderBottom: '1px solid rgba(0,229,255,0.08)',
          }}
        >
          <div
            style={{
              width: 42,
              height: 42,
              borderRadius: '50%',
              flexShrink: 0,
              background: 'rgba(0,229,255,0.12)',
              border: `1px solid ${cyan}`,
              color: cyan,
              fontSize: '0.88rem',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textTransform: 'uppercase',
            }}
          >
            {user?.name?.charAt(0) || '?'}
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ color: '#fff', fontWeight: 600, fontSize: '0.72rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {user?.name || '—'}
            </div>
            {user?.username && (
              <div style={{ color: cyan, fontSize: '0.58rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                @{user.username}
              </div>
            )}
            <div style={{ color: 'var(--text-muted)', fontSize: '0.58rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {user?.userCode || '—'}
            </div>
            <div style={{ color: 'var(--text-muted)', fontSize: '0.58rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {user?.email || '—'}
            </div>
          </div>
        </div>

        <Nav className="flex-column mt-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path.split('?')[0]
              && (!item.path.includes('?') || location.search === `?type=earning`);
            return (
              <Nav.Link
                key={item.path}
                onClick={() => handleNav(item.path)}
                className={isActive ? 'active-link' : ''}
                style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}
              >
                <span style={{ fontSize: '1rem', width: '18px', textAlign: 'center', flexShrink: 0 }}>
                  {item.icon}
                </span>
                {item.label}
              </Nav.Link>
            );
          })}
        </Nav>

        <div className="mt-auto px-4 py-3" style={{ borderTop: '1px solid rgba(0,229,255,0.08)' }}>
          <button className="drawer-footer-link" onClick={handleLogout}>
            ⏻&nbsp; Logout
          </button>
          <div style={{ marginTop: '1rem', fontSize: '0.72rem', color: 'var(--text-muted)' }}>
            © 2025 OneCircle. All rights reserved.
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Drawer;
